import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/css.svg
 */
const IconCss: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2h9l5 5v13a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2zm0 1h8v5h5v12a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1zm12.586 4L15 3.414V7h3.586z"
      fill="currentColor"
    />
    <path
      d="M8.548 18.096c-.737 0-1.346-.245-1.827-.735-.48-.49-.721-1.094-.721-1.813 0-.723.24-1.328.721-1.813.48-.49 1.09-.735 1.827-.735.443 0 .852.105 1.225.315.378.205.672.485.882.84l-.833.483a1.27 1.27 0 00-.518-.511 1.515 1.515 0 00-.756-.189c-.476 0-.861.15-1.155.448-.29.299-.434.686-.434 1.162 0 .471.145.856.434 1.155.294.299.679.448 1.155.448.28 0 .532-.06.756-.182a1.27 1.27 0 00.518-.511l.833.483c-.21.355-.502.637-.875.847a2.514 2.514 0 01-1.232.308zM12.606 18.096c-.485 0-.893-.107-1.225-.322a1.759 1.759 0 01-.7-.889l.826-.483c.192.5.567.749 1.127.749.271 0 .47-.049.595-.147a.452.452 0 00.19-.371.442.442 0 00-.232-.399c-.154-.098-.429-.203-.826-.315a5.41 5.41 0 01-.56-.196 2.677 2.677 0 01-.455-.259 1.11 1.11 0 01-.343-.42 1.364 1.364 0 01-.119-.588c0-.443.157-.796.47-1.057a1.718 1.718 0 011.14-.399c.397 0 .745.098 1.043.294.304.191.54.46.707.805l-.812.469c-.196-.42-.508-.63-.938-.63-.2 0-.359.047-.476.14a.425.425 0 00-.168.35c0 .154.063.28.19.378.13.093.377.196.741.308.15.047.262.084.336.112.08.023.185.063.315.119a1.595 1.595 0 01.56.336c.094.08.164.161.21.245.052.084.094.187.126.308.038.117.056.245.056.385 0 .453-.165.812-.497 1.078-.326.266-.753.399-1.28.399z"
      fill="currentColor"
    />
    <path
      d="M16.222 18.096c-.485 0-.894-.107-1.225-.322a1.758 1.758 0 01-.7-.889l.826-.483c.191.5.567.749 1.127.749.27 0 .47-.049.595-.147a.452.452 0 00.19-.371.442.442 0 00-.232-.399c-.154-.098-.43-.203-.826-.315a5.402 5.402 0 01-.56-.196 2.673 2.673 0 01-.455-.259 1.11 1.11 0 01-.343-.42 1.363 1.363 0 01-.119-.588c0-.443.156-.796.47-1.057A1.718 1.718 0 0116.11 13c.397 0 .744.098 1.043.294.303.191.54.46.707.805l-.812.469c-.196-.42-.509-.63-.938-.63-.2 0-.36.047-.476.14a.425.425 0 00-.168.35c0 .154.063.28.19.378.13.093.377.196.741.308.15.047.261.084.336.112.08.023.184.063.315.119a1.595 1.595 0 01.56.336c.093.08.163.161.21.245.051.084.093.187.126.308.037.117.056.245.056.385 0 .453-.166.812-.497 1.078-.327.266-.754.399-1.28.399z"
      fill="currentColor"
    />
  </svg>
);

export default IconCss;
